import React from 'react';
import bowser from 'bowser';
import { makeStyles } from 'tss-react/mui';
import { useSnackbar } from 'notistack';
import CopyToClipboard from 'react-copy-to-clipboard';
import IconButton from '@mui/material/IconButton';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import { Theme } from '@mui/material/styles';

interface Props {
  value: string;
  className?: string;
}

function CopyButton({ value, className }: Props) {
  const { classes } = useStyles();

  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = () => {
    enqueueSnackbar(`"${value}" copied to clipboard!`, { variant: 'success' });
  };

  return (
    <CopyToClipboard text={value} onCopy={handleCopy}>
      <IconButton aria-label="copy" size="large" className={className}>
        <FileCopyOutlinedIcon className={classes.icon} />
      </IconButton>
    </CopyToClipboard>
  );
}

const useStyles = makeStyles()((theme: Theme) => {
  return {
    root: {},
    icon: {
      width: 16,
      height: 16,
    },
  };
});

export default CopyButton;
